import { Button, Flex, Link, Typography } from '@iheartjane/reefer';
import { Form, FormFieldWrapper } from '@iheartjane/reefer-hook-form';
import VerificationInput from 'react-verification-input';

import styles from './mfa.module.css';

interface MfaFormProps {
  contactDisplay: string;
  errorVerifyingCode: string | null;
  onCancel?: () => void;
  onSubmit: (values: { code: string }) => void;
  resendCode: () => void;
  showCancelButton?: boolean;
  showResendButton: boolean;
  usesEmail?: boolean;
}

export const MfaForm = ({
  contactDisplay,
  errorVerifyingCode,
  onCancel,
  onSubmit,
  resendCode,
  showCancelButton = true,
  showResendButton,
  usesEmail = false,
}: MfaFormProps) => {
  return (
    <Form onSubmit={onSubmit} name="mfa">
      <Flex
        width="100%"
        height="100%"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Typography textAlign="center">
          Enter the code sent to {usesEmail ? 'your email' : 'phone number'}
        </Typography>
        <Typography textAlign="center" mb={24}>
          {contactDisplay}
        </Typography>
        <Flex mb={24} width="100%" justifyContent="center">
          <FormFieldWrapper
            defaultValue=""
            name="code"
            required
            minLength={6}
            render={({ field }) => (
              <VerificationInput
                autoFocus
                value={field.value}
                onChange={(value: string) => field.onChange(value)}
                placeholder=""
                validChars="0-9"
                inputProps={{
                  inputMode: 'numeric',
                  'aria-label': 'Verification code',
                }}
                classNames={{
                  character: errorVerifyingCode
                    ? styles['characterError']
                    : styles['character'],
                  characterSelected: errorVerifyingCode
                    ? styles['characterSelectedError']
                    : styles['characterSelected'],
                }}
              />
            )}
          />
        </Flex>

        {errorVerifyingCode && (
          <Typography color="error" textAlign="center" mb={16}>
            {errorVerifyingCode}
          </Typography>
        )}

        <Flex flexDirection="column" width="100%">
          <Flex gap={16} className={styles['buttonGroup']}>
            {showCancelButton && (
              <Button
                label="Cancel"
                onClick={onCancel}
                variant="tertiary"
                full
              />
            )}
            <Form.SubmitButton label="Verify" full />
          </Flex>

          {showResendButton && (
            <Link mt={16} onClick={resendCode} mx="auto">
              Resend code
            </Link>
          )}

          {!showResendButton && (
            <Flex alignItems="center" flexDirection="column" mt={16}>
              <Typography textAlign="center">Didn't receive a code?</Typography>
              <Link href="https://customer-support.iheartjane.com/s/contactsupport">
                Contact support
              </Link>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Form>
  );
};
